import React from 'react';
import { List as RAList } from 'react-admin';

const List = props => <RAList perPage={25} {...props} />;

export default List;
